

























import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import {DebtEmployee, DebtPostOffice} from "@/interfaces/entity";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import LadingPaymentTypeLabel from "../../../../../ladings/List/components/PaymentTypeLabel.vue";

const columns = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: 80
  },
  {
    title: "Mã vận đơn",
    dataIndex: "billLading.ladingCode",
    key: "ladingCode",
  },
  // {
  //   title: "Tổng cước",
  //   dataIndex: "billLading.totalFee",
  //   key: "totalMoney",
  //   scopedSlots: {customRender: 'totalFee'},
  // },
  {
    title: "Tổng thu",
    dataIndex: "money",
    key: "money",
    scopedSlots: {customRender: 'money'},
  },
];
@Component({
  name: "ReceiptDebtPostOfficeTable",
  components: {LadingPaymentTypeLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
  @Prop() readonly debtPostOffices!: Array<DebtPostOffice>;
  @PropSync('debtIds', { default: () => [], type: Array }) syncDebtIds!: number[];
  columns = columns;

  onSelectedIdsChange(selectedIds: any) {
    this.syncDebtIds = selectedIds;
  }
}
